import { useTranslation } from 'react-i18next'

import { BulkApproveModal } from '~/pages/SpotBidding/components/BulkApproveModal'
import { BulkApprovePanel } from '~/pages/SpotBidding/components/BulkApprovePanel'
import { useSpotBulkApproval } from '~/pages/SpotBidding/hooks/useSpotBulkApproval'

type Props = Parameters<typeof useSpotBulkApproval>[0]

/**
 * 通常入札タブのまとめて承認 (AC-BSP-118) の入口・結果・確認モーダル。
 *
 * 開閉・実行中・結果の state をこの component に閉じ込める。 ページ本体の state にすると、
 * モーダルの開閉のたびに一覧・承認状態バナーを含むページ全体が描き直され、 確認モーダルを
 * 開くまでの時間が伸びる (ブロック入札は数千グループでページが重い)。 ページ本体へ state を
 * 戻さないこと。 入口は承認状態バナーの上に置くが、 確認モーダルは portal なのでここに同居させてよい。
 */
export const SpotBulkApproval = (props: Props): React.ReactElement => {
  const { t } = useTranslation()
  const flow = useSpotBulkApproval(props)
  return (
    <>
      <BulkApprovePanel
        flow={flow}
        hint={
          flow.notApproverCount > 0
            ? t('page:biddingSpot.bulkApprove.entryHintNotApprover', {
                count: flow.notApproverCount,
              })
            : t('page:biddingSpot.bulkApprove.entryHint')
        }
      />
      <BulkApproveModal flow={flow} targetDate={props.targetDate} />
    </>
  )
}
